import { GeneralPropsType } from "@/common/types";
import clsx from "clsx";
import styles from "./index.module.css";
import DynamicFontSize from "../DynamicFontSize";
export interface UnderlineTextPropsType extends GeneralPropsType {
  underLineStyle?: "dashed" | "solid" | "none";
}
function UnderlineText({
  children,
  className,
  underLineStyle = "solid",
  onClick
}: UnderlineTextPropsType) {
  return <DynamicFontSize fontSize={12} onClick={onClick} className={clsx(styles.text, "", className)} style={{
    borderBottom: underLineStyle != "none" ? `1px currentColor ${underLineStyle}` : ""
  }} data-sentry-element="DynamicFontSize" data-sentry-component="UnderlineText" data-sentry-source-file="index.tsx">
            {children}
        </DynamicFontSize>;
}
export default UnderlineText;